import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  CardContent,
  CardHeader,
  Select,
} from "@material-ui/core";
import {
  Box,
  Button, CardActions, FormControl, Grid,
  Input, InputLabel, MenuItem, Switch
} from "@mui/material";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AutocompleteTemplate from "../Autocomplete";
import { getAccountDetails, updateAccount } from "./AccountUtil";
import UploadFileBtn from "../Helper/UploadFileBtn/UploadFileBtn";
import {
  downloadDocument,
  getDocuments,
  uploadDocument,
} from "../Helper/DocumentsHelper";
import { DocumentsTypes } from "../Enum/DocumentsType";
import userRoles from "../../configs/userRolesConfigs";
import { EstimatedAnnualRevenueEnum } from "../../Models/user";

const digitsAndEnglishOnly = /^[A-Za-z-0-9]+$/;
let validationSchema = Yup.object().shape({
  email_from_refund: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .matches(
      digitsAndEnglishOnly,
      "Must contein Only English letters or Digits"
    )
    .min(8, "Must contein at least 8 characters!")
    .max(32, "Must contein until 32 characters!"),
  account_name: Yup.string().required("Required"),
  salesperson_name: Yup.mixed()
});

const AccountForm = () => {
  const [account, setAccount] = useState({ status: true });
  const [errorMessage, seterrorMessage] = useState("");
  const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const userRole = useSelector((state: any) => state.general.userRol);

  const onSubmit = async (data) => {
    data["seller_id"] = account["seller"]["id"];
    if (account["analyst"] && account["analyst"] !== undefined) {
      data["analyst_id"] = account["analyst"]["id"];
    } else {
      data["analyst_id"] = null;
    }
    if (account["salesperson"] && account["salesperson"] !== undefined) {
      data["salesperson_id"] = account["salesperson"]["id"];
    } else {
      data["salesperson_id"] = null;
    }
    if (account["affiliate"] && account["affiliate"] !== undefined) {
      data["affiliate_id"] = account["affiliate"]["id"];
    } else {
      data["affiliate_id"] = null;
    }
    data["jobs"] = daysSelected;
    if (data["commission_percentage"] === "") {
      data["commission_percentage"] = null;
    }
    var response = await updateAccount(dispatch, id, data);
    if (response["message"] === "success")
      navigate("/layout/administrator/accounts/");
    else {
      seterrorMessage(response["message"]);
    }
  };

  const dispatch = useDispatch();
  let analystsList = useSelector((state: any) => state.user.anylysts_list);
  let sellersList = useSelector((state: any) => state.user.sellers_list);
  let salespersonList = useSelector((state: any) => state.user.salesperson_list);
  let affiliatesList = useSelector((state: any) => state.user.affiliates_list);

  const setValue = (id, value) => {
    setAccount({
      ...account,
      [id]: value,
    });
  };

  const days = [
    { id: 0, name: "Monday" },
    { id: 1, name: "Tuesday" },
    { id: 2, name: "Wednesday" },
    { id: 3, name: "Thursday" },
    { id: 4, name: "Friday" },
    { id: 5, name: "Saturday" },
    { id: 6, name: "Sunday" },
  ];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      var account = await getAccountDetails(dispatch, id);
      setAccount(account);
      setDayIfNotEmpty(account["job_day1"], account["job_day2"]);
      setDocuments(await getDocuments(dispatch, DocumentsTypes.DOUMENT, id));
    };
    if (id) {
      fetchData();
    }
  }, [id]);

  const setDayIfNotEmpty = (day1, day2) => {
    const days = [];
    if (day1) days.push(day1);
    if (day2) days.push(day2);
    setDaysSelected(days);
  };

  const [daysSelected, setDaysSelected] = React.useState<string[]>([]);
  const idSeller = "seller";
  const idAnalyst = "analyst";
  const handleChangeDay = (event) => {
    var {
      target: { value },
    } = event;
    if (value.length > 2) value = value.slice(-2);
    setDaysSelected(typeof value === "string" ? value.split(",") : value);
  };
  const importDocument = async (file) => {
    setDocuments(
      await uploadDocument(dispatch, file, DocumentsTypes.DOUMENT, id)
    );
  };

  const download = async (item) => {
    try {
      await downloadDocument(dispatch, id, item.id, item.name);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <Grid className="account-grid" container justifyContent="center">
      <Grid item md={6}>
        <CardHeader title="Account Form" className="text-center"></CardHeader>
        {account["account_name"] && (
          <Formik
            initialValues={account}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ dirty, isValid, values, handleChange, handleBlur, setFieldValue }) => {
              return (
                <Form className="page-form">
                  <CardContent>
                    <Grid item container spacing={2}>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>User Name*</InputLabel>
                        <AutocompleteTemplate
                          id={idSeller}
                          title={''}
                          disabled={userRole !== userRoles.admin}
                          options={sellersList}
                          defaultValue={values.seller || ""}
                          setValue={setValue}
                        ></AutocompleteTemplate>
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Account Name*</InputLabel>
                        <Field
                          name="account_name"
                          disabled={userRole !== userRoles.admin}
                          value={values.account_name || ""}
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Password</InputLabel>
                        <Field
                          name="password"
                          value={values.password || ""}
                          disabled={userRole !== userRoles.admin}
                          type="password"
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Email</InputLabel>
                        <Field
                          name="email_from_refund"
                          value={values.email_from_refund || ""}
                          type="text"
                          component={TextField}
                        />
                      </Grid>
                       <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Amazon authorized url </InputLabel>
                        <Field
                          name="amazon_authorized_url"
                          value={values.amazon_authorized_url || ""}
                          type="text"
                          component={TextField}
                        />
                      </Grid>
                      <Grid className="jobs" item xs={12} sm={6} md={12}>
                        <InputLabel id="demo-simple-select-label">
                          Jobs
                        </InputLabel>
                        <FormControl fullWidth>
                          <Select
                            name="jobs"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={daysSelected || ''}
                            onChange={handleChangeDay}
                            onBlur={handleBlur}
                            multiple
                            variant="outlined"
                            MenuProps={MenuProps}
                            disabled={userRole !== userRoles.admin}
                          >
                            {days.map((day) => (
                              <MenuItem key={day.id} value={day.id}>
                                {day.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Analyst Name</InputLabel>
                        <AutocompleteTemplate
                          id={idAnalyst}
                          disabled={userRole !== userRoles.admin}
                          title={''}
                          options={analystsList}
                          defaultValue={values.analyst || ""}
                          setValue={setValue}
                        ></AutocompleteTemplate>
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Salesperson Name</InputLabel>
                        <AutocompleteTemplate
                          id={userRoles.salesperson}
                          title={''}
                          name='salesperson_name'
                          options={salespersonList}
                          disabled={userRole !== userRoles.admin}
                          defaultValue={values.salesperson || ""}
                          setValue={setValue}
                        ></AutocompleteTemplate>
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Affiliate Name</InputLabel>
                        <AutocompleteTemplate
                          id={userRoles.affiliate}
                          title={''}
                          name="affiliate_name"
                          options={affiliatesList}
                          disabled={userRole !== userRoles.admin}
                          defaultValue={values.affiliate || ""}
                          setValue={setValue}
                        ></AutocompleteTemplate>
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel id="demo-simple-select-label">
                          Estimated annual FBA revenue
                        </InputLabel>
                        <FormControl fullWidth>
                          <Select
                            name="estimated_annual_revenue"
                            labelId="estimated-annual-revenue-label"
                            id="estimated-annual-revenue"
                            value={values.estimated_annual_revenue || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            variant="outlined"
                            disabled={userRole !== userRoles.admin}
                          >
                            {Object.keys(EstimatedAnnualRevenueEnum).map((key) =>
                              <MenuItem value={key} key={key}>{EstimatedAnnualRevenueEnum[key]}</MenuItem>)
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={12}>
                        <InputLabel>Commission Percentage</InputLabel>
                        <Field
                          name="commission_percentage"
                          value={values.commission_percentage || ""}
                          type="text"
                          component={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={12} mb={1}>
                        <InputLabel id="demo-simple-select-label">
                          Is Send Invite
                        </InputLabel>
                        <FormControl fullWidth>
                          <Select
                            name="is_send_invite"
                            labelId="is-send-invite-label"
                            id="is-send-invite"
                            value={values.is_send_invite ? 'True' : 'False'} // Map boolean to string
                            onChange={(e) => setFieldValue("is_send_invite", e.target.value === 'True')} // Map back
                            onBlur={handleBlur}
                            variant="outlined"
                          >
                            <MenuItem value={"False"}>No</MenuItem>
                            <MenuItem value={"True"}>Yes</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid>
                        <Grid item xs={12} sm={6} md={12}>
                          <Switch
                            name="status"
                            value="Y"
                            color="primary"
                            checked={values.status !== "N"}
                            disabled={userRole !== userRoles.admin}
                            onChange={(event, checked) => {
                              setFieldValue("status", checked ? "Y" : "N");
                            }}
                          />
                          <label>Status</label>
                          {errorMessage != "" && (
                            <div className="error-message">
                              {errorMessage}
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <CardActions>
                    <Button
                      disabled={!isValid}
                      type="submit"
                      sx={{ mt: 1 }}
                      className="blue-btn w-100 h-50p"
                    >
                      Save
                    </Button>
                  </CardActions>
                </Form>
              );
            }}
          </Formik>
        )}
        <Box sx={{ maxWidth: "80%", margin: "auto", pt: 4 }}>
          <UploadFileBtn
            onSubmit={importDocument}
            multiple={false}
            title="Upload Documents"
            buttonText="Upload"
            classes="m-auto small-upload-file"
            exdendStyle={true}
          ></UploadFileBtn>
          <Box p={4} mt={3}>
            {documents.map((item) => {
              return (
                <div
                  className="file"
                  key={item.id}
                  onClick={() => download(item)}
                >
                  {item.name}
                </div>
              );
            })}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
export default AccountForm;
